const global = window

inputs.types.code = function (data, name, niceName, type, input, parent, inputWindow) {
    if (typeof pluginCode === 'undefined' && typeof plugins !== 'undefined' && plugins.ace) {
        global.pluginCode = new plugins.ace('.codeEditor');
    }
    if (typeof pluginCode !== 'undefined' && pluginCode) {
        pluginCode.init(input);
    }
    return data
}
